import TypeUtil from '@/util/type.util'

export const INIT_PUBLIC_FORM = 'INIT_PUBLIC_FORM'
export const SET_SHARE_PAYLOAD = 'SET_SHARE_PAYLOAD'
export const SET_GLOBAL_DATA_READY = 'SET_GLOBAL_DATA_READY'

const publicFormStore = {
  namespaced: true,
  state: {
    shareConfig: {},
    sharePayload: null,
    publicConfig: {},
    shareButton: null
  },
  mutations: {
    [INIT_PUBLIC_FORM](state, data) {
      if (TypeUtil.isObject(data)) {
        state.shareConfig = data.shareConfig
        state.shareButton = data.shareButton || {}
        state.publicConfig = data
      }
    },
    [SET_SHARE_PAYLOAD](state, payload) {
      state.sharePayload = payload
    },
    [SET_GLOBAL_DATA_READY](state, flag) {
      state.shareConfig = Object.assign({}, state.shareConfig, { ready: flag })
    }
  },
  actions: {},
  getters: {}
}

export default publicFormStore
